import React from 'react';
import {  makeStyles, Button, TextField, InputAdornment } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/SearchRounded'; 


const focusedColor = "#2a9c6c";
const useStyles = makeStyles((theme) => ({
    edtText: {
        // input label when focused
        "& label.Mui-focused": {
            color: focusedColor
        },
        // focused color for input with variant='standard'
        "& .MuiInput-underline:after": {
            borderBottomColor: focusedColor
        },
        // focused color for input with variant='filled'
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: focusedColor
        },
        // focused color for input with variant='outlined'
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
            borderColor: focusedColor
            }
        }
    },
    buttonFind : {
        color:'white',
        backgroundColor:'#2a9c6c',
        margin: theme.spacing(1),
    }
}))

export default function SearchComponent({placeholder, onSearch, onDelete, onTypeChange}){
    // update here
    const [searchName, setSearchName] = React.useState(null)
    const [showDelete, setShowDelete] = React.useState(false)
    const classes = useStyles()

    return (
        <div style={{ display: 'flex', alignItems: 'center', marginTop: -10, marginBottom: 10 }}>
            <TextField
                className={classes.edtText}
                size="small"
                variant="outlined"
                placeholder={placeholder ?? 'Ketik Disini'}
                value={searchName}
                onChange={(e)=>{
                    setSearchName(e.target.value)
                    e.target.value.length > 0 ? setShowDelete(true):setShowDelete(false)
                    if(onTypeChange != null){
                        onTypeChange(e.target.value)
                    }
                }}
                InputProps={{
                    endAdornment:
                    <InputAdornment position="end">
                        {showDelete ? <CloseIcon
                        titleAccess="batal"
                        style={{ cursor: 'pointer' , color:'#2a9c6c'}}
                        onClick={() => {
                            onDelete()
                            setShowDelete(false)
                            setSearchName('')
                        }}/>:null}
                    </InputAdornment>
                }}
            />
            <Button
                onClick={()=>{
                    console.log(searchName)
                    onSearch(searchName)
                }}
                variant="contained"
                className={classes.buttonFind}
                startIcon={<SearchIcon />}
            >Cari</Button>

        </div>
    )
}